import { render, staticRenderFns } from "./ButtonClose.vue?vue&type=template&id=315f9da0&scoped=true&"
import script from "./ButtonClose.vue?vue&type=script&lang=js&"
export * from "./ButtonClose.vue?vue&type=script&lang=js&"
import style0 from "./ButtonClose.vue?vue&type=style&index=0&id=315f9da0&prod&lang=stylus&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "315f9da0",
  null
  
)

export default component.exports

/* nuxt-component-imports */
installComponents(component, {ButtonBlob: require('/opt/build/repo/components/ButtonComponents/ButtonBlob.vue').default})
